import { loadAsyncComponent, show, getComponent } from "./common";
import PrintingSelector from "./printing-selector";

export default class ProductPrintingOptions{
    private baseElement: HTMLElement;
    private hasPrice: boolean;
    private productId: number;
    private productGuid: string;
    private productCount: number;
    private isCalculatorActive: boolean;
    private isOutOfStock: boolean;

    static componentName = 'ProductDetailPrintingOptions';

    constructor(baseElement: HTMLElement){
        this.baseElement = baseElement;
        this.isCalculatorActive = this.baseElement.dataset.isCalculatorActive && this.baseElement.dataset.isCalculatorActive.toLowerCase() === 'true';
        this.hasPrice = this.baseElement.hasAttribute('data-has-price');
        this.productId = Number(this.baseElement.dataset.productId)
        this.productGuid = this.baseElement.dataset.productGuid;
    }

    async load(): Promise<void>{
        const loadedElement = await loadAsyncComponent(this.baseElement);
        if(!loadedElement){
            return;
        }
        this.baseElement = loadedElement;
        this.initAfterLoad();
    }

    private initAfterLoad(): void {
        this.isOutOfStock = this.baseElement.dataset.productOutOfStock && this.baseElement.dataset.productOutOfStock == 'True';
        this.initPrintingOptionLinks();
        this.showPrintingOptionsNavLink();
    }    
    
    private showPrintingOptionsNavLink() {
        const link = document.querySelector('#printing-options-nav-link') as HTMLElement;
        const list = document.querySelector('[data-component-part="position-list"]');
        link && list && show(link);
    }

    public initPrintingOptionLinks(): void {
        const links = this.baseElement.querySelectorAll('[data-printing-position-id]');

        links && links.forEach(element => {
            new PrintingSelector(element as HTMLAnchorElement, this.hasPrice, this.productId, this.productGuid, this.productCount, this.isCalculatorActive, this.isOutOfStock).init();
        });
    }

    public setProductCount(productCount: number){
        this.productCount = productCount;
    }

}
